export interface BulkImportRow {
  id: string;
  name: string;
  description: string;
  location: string;
  latitude: string;
  longitude: string;
  category: string;
  coastal_area: string;
  country_short_code: string;
  min_depth: string;
  max_depth: string;
  berth_capacity: string;
}

export interface BulkImportFieldError {
  row: number;
  field: string;
  message: string;
}

export const BULK_IMPORT_MAX_ROWS = 30;
export const BULK_IMPORT_MIN_ROWS = 1;

export const BULK_IMPORT_JSON_FIELDS = [
  'name',
  'description',
  'location',
  'latitude',
  'longitude',
  'category',
  'coastal_area',
  'country_short_code',
  'min_depth',
  'max_depth',
  'berth_capacity',
] as const;
